export default __webpack_public_path__ + "static/media/03_photo.b7d00b3a.jpg";